export default "__VITE_ASSET__CFZMKJU8__"